import type { WindowEntryChip } from "./types";
import { ProductActions } from "./ProductActions";

type ProductChipProps = {
    chip: WindowEntryChip;
    readonly?: boolean;
    onRemove?: () => void;
};

export function ProductChip({ chip, readonly, onRemove }: ProductChipProps) {
    return (
        <div
            data-testid="confirm-product-entry"
            className="flex items-center gap-3"
        >
            <div className="hidden size-48 shrink-0 rounded-md border border-gray-200 overflow-hidden bg-gray-50 p-2 sm:block">
                {chip.productImageUrl ? (
                    <img
                        src={chip.productImageUrl}
                        alt={chip.productName}
                        className="h-full w-full rounded-sm object-cover"
                    />
                ) : (
                    <div className="h-full w-full bg-gray-200" />
                )}
            </div>

            <ProductActions
                quantity={chip.quantity}
                price={chip.price}
                productName={chip.productName}
                className="w-32"
                onRemove={readonly ? undefined : onRemove}
                removeTestId="remove-window-btn"
            />
        </div>
    );
}
